import ApiService from '@api/api-service';

let VCA = VCA || {};

VCA.UrgentCareVWRWaitTime = (function ($) {

    let ui = {};

    function cacheUI() {
        ui.$VWRMessage = $('.uc-vwr-msg');
        ui.$WaitTime = $('.js-vwr-waittime');
        ui.$LastUpdated = $('.js-vwr-lastupdated');
        ui.$VWRComponent = $('.uc-hero-panel__item.vwr');
        ui.$VWRZeroNav = $('.header-urgentcare-vwr');
        ui.$VWRLabel = $('#VirtualWaitingRoomLabel');
        ui.hospitalId = $('#VWRInfoWrapper').data('hospital-au');
    }

    async function getCurrentWaitTime() {
        const url = `/urgentcare-api/get-virtual-wait-time?id=${ui.hospitalId}`;
        let api = new ApiService(url);

        const { data, success, error } = await api.get();
        
        if (!success || (error !== null && error !== '')) {
            console.log("API Virtual Wait Time Error: ", error);
        } else { 
            let results = data;

            if (results == null || results == undefined) {
                // ui.$VWRComponent.hide();
                console.log("Error: API results are empty, null, or undefined.");
            } else {
                //SUCCESS
                updateMsgAndWaitTime(results);
            }
        }
        updateTimeStamp(); 
    }

    function updateMsgAndWaitTime(data) {
        const VWRIsOpen = data.isOpen;

        if (VWRIsOpen) {
            $('#VWRInfoWrapper').css('pointer-events', '');
            ui.$VWRZeroNav.show();
            ui.$VWRMessage.text(data.message);
            ui.$WaitTime.text("Our current estimated wait time is " + getTickToHours(data.waitingTimeInMinutes));
        } else {
            ui.$VWRZeroNav.hide();
            ui.$VWRLabel.text('Virtual Waiting Room');
            
            if (data.errorMessage !== null || data.errorMessage !== '') {
                ui.$VWRMessage.text(data.errorMessage);
            } else {
                ui.$VWRMessage.text(data.message);
            }
        }
    }

    function getTickToHours(time) {
        let num = time;
        let hours = (num / 60);
        let rhours = Math.floor(hours);
        let minutes = (hours - rhours) * 60;
        let rminutes = Math.round(minutes);

        if (rhours < 1) {
            return `${rminutes} minutes`;
        } else if (rhours == 1) {
            return `${rhours} hour and ${rminutes} minutes`;
        } else {
            return `${rhours} hours and ${rminutes} minutes`;
        }

    }

    function updateTimeStamp() {
        const timeElapsed = Date.now();
        const today = new Date(timeElapsed);
        const currentDay = today.toLocaleDateString();
        const currentHours = today.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

        ui.$LastUpdated.text(`${currentDay} ${currentHours}`);
    }

    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
    
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
    
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    function init() {
        let isUrgentCarePage = $('#is-urgent-care').data('is-uc');

        if (isUrgentCarePage == 'True') {
            waitForElm('.grecaptcha-badge').then((el) => {
                $(el).css('visibility', 'hidden');
            });
            $('#VWRInfoWrapper').css('pointer-events', 'none');
            cacheUI();
            getCurrentWaitTime();
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    $(document).ready(function() {
        VCA.UrgentCareVWRWaitTime.init();
    });
});
